const toNumber = (str: string | number): number => Number(str);

const sort = (a: string | number, b: string | number): number => {
  if (toNumber(a) && toNumber(b)) {
    return toNumber(a) - toNumber(b);
  }

  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b);
  }

  return 0;
};

export default sort;
